import { Injectable } from '@angular/core';
import { Pessoa } from '@tivic-team/manager-ts/dist/grl';
import { PessoaController } from 'app/controllers/grl/pessoa.controller';
import { ApiService } from '../api-service.interface';
import { LoaderService } from '../loader.service';
import { PessoaSearch } from './pessoa.search';


@Injectable()
export class PessoaService implements ApiService<Pessoa>{

    constructor(
        private _pessoaController: PessoaController,
        private _loaderService: LoaderService
    ){}
    create(entity: Pessoa): Promise<Pessoa> {
        throw new Error('Method not implemented.');
    }
    update(entity: Pessoa): Promise<Pessoa> {
        throw new Error('Method not implemented.');
    }

    async find(pessoaSearch?:PessoaSearch):Promise<Pessoa[]>{
        try{return await this._pessoaController.find(pessoaSearch && pessoaSearch.getFilters() || null);}
        catch(error){return [];}
    }

    async getPessoaByCPFCNPJ(nrCpfCnpj:string):Promise<Pessoa>{
        this._loaderService.show();
        return this._pessoaController.getPessoaByCPFCNPJ(nrCpfCnpj).finally(() => this._loaderService.hide());
    }

    async get(cdPessoa:number):Promise<any>{
        this._loaderService.show();
        return await this._pessoaController.get(cdPessoa).finally(() => this._loaderService.hide());
    }
    
    async getAll():Promise<Pessoa[]>{
        this._loaderService.show();
        return this._pessoaController.find().finally(() => this._loaderService.hide());
    }

    async getArquivos(cdPessoa:number):Promise<any>{
        this._loaderService.show();
        return this._pessoaController.getArquivos(cdPessoa).finally(()=> this._loaderService.hide());
    }

    async getPermissionario(pessoaSearch?:PessoaSearch):Promise<Pessoa[]>{
        this._loaderService.show();
        return await this._pessoaController.getPermissionario(pessoaSearch && pessoaSearch.getFilters() || null).finally(() => this._loaderService.hide());
    }
}